<template>
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5Z"
      stroke="currentcolor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.99982 6.66683C9.88482 6.66683 9.79149 6.76016 9.79232 6.87516C9.79232 6.99016 9.88565 7.0835 10.0007 7.0835C10.1157 7.0835 10.209 6.99016 10.209 6.87516C10.209 6.76016 10.1157 6.66683 9.99982 6.66683"
      stroke="currentcolor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.0007 10V14.1667"
      stroke="currentcolor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
  